import { render, staticRenderFns } from "./liveClassFestivalDetails.vue?vue&type=template&id=99e338e4&scoped=true"
import script from "./liveClassFestivalDetails.vue?vue&type=script&lang=js"
export * from "./liveClassFestivalDetails.vue?vue&type=script&lang=js"
import style0 from "./liveClassFestivalDetails.vue?vue&type=style&index=0&id=99e338e4&prod&lang=less"
import style1 from "./liveClassFestivalDetails.vue?vue&type=style&index=1&id=99e338e4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99e338e4",
  null
  
)

export default component.exports